import { useQuery } from "@tanstack/react-query";
import { getRollsInUse } from "../repositories/RollsInUseRepository";

export const useRollsInUse = (standId: number | null) =>
	useQuery({
		queryKey: ["rollsInUse", standId],
		queryFn: ({ signal }) => getRollsInUse({ standId, signal }),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
